import nBossConnection from 'modules/base/service/nBossConnection';
import PictogramDto from '../dto/PictogramDto';

class PictogramService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'pictogramControl';
	}

	/**
	 * @return {Promise<PictogramDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new PictogramService();
